import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-online_user",
  "use": "icon-online_user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-online_user\">\r\n  <path d=\"M362.645333 539.861333a275.584 275.584 0 1 1 155.52 48.042667c-223.488 0-403.370667 163.498667-403.370666 363.392a35.925333 35.925333 0 0 1-71.893334 0c0-191.061333 133.973333-352.554667 319.744-411.434667z m155.52-23.893333a203.690667 203.690667 0 1 0 0-407.338667 203.690667 203.690667 0 0 0 0 407.381334z m153.045334 361.898667l244.736-205.354667a39.936 39.936 0 1 1 51.370666 61.184l-275.370666 231.04a39.936 39.936 0 0 1-56.277334-4.906667l-114.858666-136.96a39.936 39.936 0 1 1 61.184-51.285333l89.173333 106.282667z\" p-id=\"9221\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/online_user.svg
// module id = 1Pgw
// module chunks = 215